import { render, staticRenderFns } from "./GoodsClassList.vue?vue&type=template&id=7b9df510&scoped=true&"
import script from "./GoodsClassList.vue?vue&type=script&lang=js&"
export * from "./GoodsClassList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClassList.vue?vue&type=style&index=0&id=7b9df510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9df510",
  null
  
)

export default component.exports